import dayjs from 'dayjs';

export const useNextRechargeInDays = () => {
  const today = dayjs();
  const nextMonth = today.add(1, 'month').startOf('month');
  const days = nextMonth.diff(today, 'day') + 1;

  return {
    days: days.toString(),
    nextMonth: nextMonth.format('DD/MM/YYYY'),
  };
};
